define('SageDotCom/Components/ResourceListing',[
	"jquery",
	"underscore",
	"eventManager",
	'SageDotCom/DataLayer/tealium',
	'SageDotCom/DataLayer/Util/trackingHelper',
	'SageDotCom/DataLayer/Events/searchSelection',
	'SageDotCom/DataLayer/Events/searchRefinement',
	'SageDotCom/DataLayer/Global/slider',
	"text!SageDotCom/Components/Templates/ResourceListing.html",
	'ellipsis',
	'SageDotCom/Components/SlickSliderSettings',
	"SageDotCom/Utility/sageMatchHeight"
], function ($, _, eventManager, tealium, trackingHelper, searchSelection, searchRefinement, sliderTracker, resourceListingTemplate, ellipsisConfig, SlickSliderSettings, SageMatchHeight) {

	function ResourceListing(scope, allLabelText, resources, slidesToShow, slidesToScroll, responsiveDisplay) {
		resources = JSON.parse(resources);
		var FacetArray = [];
		var ResourceListingArray = [];

		var ResourceStringValue = "[" + resources["m_StringValue"].replace(/}{/g, "},{") + "]";
		var ResourceArray = $.parseJSON(ResourceStringValue);

		for (var i = 0; i < ResourceArray.length; i++) {
			var allObject = {
				"AllLabelText": allLabelText
			};
			$.extend(ResourceArray[i], allObject);
			ResourceListingArray.push(ResourceArray[i]);
		}

		$.each(ResourceArray, function (objectkey, objectvalue) {
			$.each(objectvalue,
				function (facetkey, facetValue) {
					if (facetkey === "IndustryType") {
						$.each(facetValue,
							function (key, value) {
								FacetArray.push(value);
							});
					}
				});
		});

		var $Resources = $(".score-slick-slider", scope);
		addFacetLi(ResourceListingArray, unique(FacetArray).sort(), allLabelText, $Resources, resourceListingTemplate);

		setSlider(scope, ResourceListingArray,
			allLabelText,
			$Resources,
			resourceListingTemplate,
			responsiveDisplay, allLabelText, slidesToShow, slidesToScroll);

		var timeoutSS;
		var saveWidthSS = $(window).width();
		$(window).resize(function () {
			if (saveWidthSS != $(window).width()) {
				saveWidthSS = $(window).width();
				clearTimeout(timeoutSS);
				timeoutSS = setTimeout(function () {
					setSlider(scope, ResourceListingArray,
						allLabelText,
						$Resources,
						resourceListingTemplate,
						responsiveDisplay, allLabelText, slidesToShow, slidesToScroll);
				}, 500);
			}


		});

		$('.score-facet-button').on('click', function (e) {
			e.preventDefault();
			$(this).addClass("active").siblings().removeClass('active');
			var facetValue = $(this).attr("data-category");
			var facetCount = $(this).children(".score-facet-count").text();
			if ($("#dropdownMenu1")) $("#dropdownMenu1 .score-facet-value").text(facetValue.replace("-", " "));
			if ($("#dropdownMenu1")) $("#dropdownMenu1 .score-facet-count").text(facetCount);

			setSlider(scope, ResourceListingArray,
				allLabelText,
				$Resources,
				resourceListingTemplate,
				responsiveDisplay, facetValue, slidesToShow, slidesToScroll);

			var eventObj = searchSelection.GenerateEventMetadata(event.currentTarget, null, facetValue);
			tealium.event(eventObj);
		});

		trackingHelper.registerTracking(scope, searchSelection.getName());
		trackingHelper.registerTracking(scope, searchRefinement.getName());

		scope.addEventListener('lazy-load-evt',
			setSlider(scope,
				ResourceListingArray,
				allLabelText,
				$Resources,
				resourceListingTemplate,
				responsiveDisplay,
				allLabelText,
				slidesToShow,
				slidesToScroll));
	}

	function unique(array) {
		return $.grep(array, function (el, index) {
			return index === $.inArray(el, array);
		});
	}

	function setSlider(scope,
		resourceListingArray,
		allLabelText,
		$resources,
		resourceListingTemplate,
		responsiveDisplay,
		facetValue,
		slidesToShow,
		slidesToScroll) {

		var facetValue = $('.score-facet-button.active').attr("data-category");
		var facetCount = $('.score-facet-button.active').children(".score-facet-count").text();
		if ($("#dropdownMenu1")) $("#dropdownMenu1 .score-facet-value").text(facetValue.replace("-", " "));
		if ($("#dropdownMenu1")) $("#dropdownMenu1 .score-facet-count").text(facetCount);

		if ($resources.hasClass('slick-initialized')) {
			$($resources).slick('unslick');
			$($resources).empty();
		}
		getListingResults($resources, resourceListingArray, resourceListingTemplate, allLabelText, scope);

		//this function creates the settings object for slick
		var slickSettings = SlickSliderSettings.getSlickSliderResourceListingSettings(slidesToShow); 

		new Promise(function (resolve, reject) {
			$($resources).on('afterChange', function () { refreshGatedContent($resources); }).slick(slickSettings);

			$resources.slick('slickUnfilter');
			if (facetValue !== "") {
				$resources.slick('slickFilter', $('.' + facetValue.replace(/\s+/g, '-')).parent().parent());
			}
			// remove old matchHeight bindings and then reapply to avoid duplicate bindings
			SageMatchHeight.prototype.applyBinding($(".sage-resources-card", scope), true, { byRow: true });
			SageMatchHeight.prototype.applyBinding($(".sage-resources-card-content", scope), true, { byRow: true });


			var elements = scope.querySelectorAll(".sage-resources-card-content .score-content-spot span");
			var ellipsis = ellipsisConfig({ lines: 4 });
			ellipsis.add(elements);

			// re-initialize global slider tracking
			$($resources).removeAttr("data-tracking");
			sliderTracker.initialize();
			//only apply to the visible gated content btns
			refreshGatedContent($resources);

			eventManager.trigger("lazy-animate-element", $resources.parent());
			resolve();
		});
	}

	function refreshGatedContent($resources) {
		$($resources).find("div.slick-slide").each(function (i, slideItem) {
			if ($(slideItem).is('.slick-active')) {
				$(slideItem).find(".open-gated-content-form").each(function (k, anchorItem) {
					$(anchorItem).attr('href', "#" + $(anchorItem).attr('data-formId'))
				});
			} else {
				$(slideItem).find(".open-gated-content-form").each(function (k, anchorItem) {
					$(anchorItem).attr('href', "javascript:void(0);")
				});
			}
		});
		if (window.gcdc) {
			window.gcdc("loadGates");
		} else {
			console.log('Info: No gated content available [window.gcdc]');
		}
	}

	function addFacetLi(ResourceListingArray, facetArray, allLabelText) {
		var liToAppend = "<li class='score-facet-button js-category active' data-category='" + allLabelText.replace(/\s+/g, '-') + "'>" +
			"<span class='score-facet-value'><a href='#'>" +
			allLabelText +
			"</a></span>" +
			"<span class='score-facet-count'>" +
			ResourceListingArray.length +
			"</span>" +
			"</li>";

		$(".sage-resource-listing-results .solution-facets-container .dropdown-menu").append(liToAppend);
		$.each(facetArray,
			function (key, value) {
				$(".sage-resource-listing-results .solution-facets-container .dropdown-menu").append("<li class='score-facet-button js-category' data-category='" + value.replace(/\s+/g, '-') + "'>" +
					"<span class='score-facet-value'><a href='#'>" + value + "</a></span>" +
					"<span class='score-facet-count'>" + getFacetCount(ResourceListingArray, value) + "</span>" +
					"</li>");
			});
	}

	function getFacetCount(ResourceListingArray, currentfacetValue) {
		var i = 0;
		$.each(ResourceListingArray, function (objectkey, objectvalue) {
			if (objectvalue && objectvalue.IndustryType && objectvalue.IndustryType.indexOf(currentfacetValue) > -1) {
				i++;
			}
		});

		return i;
	}

	function getListingResults(Resources, ResourceListingArray, ResourceListingTemplate, scope) {
		for (var i = 0; i < ResourceListingArray.length; i++) {
			var _resultTemplate = _.template(ResourceListingTemplate);
			var resultsTemplate = _resultTemplate(ResourceListingArray[i]);

			$(Resources).append(resultsTemplate);
		}
		eventManager.trigger("invoke-lazy-load", scope);
	}

	return function initResourceListing(args) {
		return args.IsExperienceEditorEditing === false
			? new ResourceListing(args.scope, args.AllLabelText, args.Resources, args.SlidesToShow, args.SlidesToScroll, args.ResponsiveDisplay)
			: null;
	}
});
